module.exports = __webpack_public_path__ + "img/Patrick Kluivert.6021b0b4.png";